import { DetailedHTMLProps, ImgHTMLAttributes } from 'react';

import backgroundImage from '@/assets/images/course-background-banner.png';
import { getCdnUrl } from '@/helpers';
import styled, { css } from '@/styled';

function PageBackgroundImage({
  className,
  ...props
}: DetailedHTMLProps<ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement> & { page?: 'course' | 'lesson' }) {
  return (
    <div className={className} data-page={props.page}>
      <img {...props} src={getCdnUrl(props.src, backgroundImage)} alt='Imagem de fundo da página' />
    </div>
  );
}

export default styled(PageBackgroundImage)(
  ({ theme }) => css`
    position: absolute;
    width: 100%;
    height: 100%;
    min-height: 720px;
    max-height: 100vh;
    overflow: hidden;
    z-index: 0;
    transition: ${theme.motionDurationMid};

    &:after,
    img {
      position: relative;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    ${theme.breakpoints.down('md')} {
      display: none;
    }

    &:after {
      content: '';
      top: 0;
      left: 0;
      position: absolute;
      transition: background ${theme.motionDurationMid};
      background: linear-gradient(270deg, rgba(250, 250, 250, 0) 50%, ${theme.variables.shadowEffect} 100%),
        linear-gradient(180deg, rgba(250, 250, 250, 0) 0%, ${theme.variables.shadowEffect} 100%);
    }

    &[data-page='lesson'] {
      &::after {
        background: linear-gradient(
          0deg,
          ${theme.variables.bgGradient} 50%,
          ${theme.variables.pageBackgroundGradient} 75%,
          ${theme.variables.pageBackgroundGradient} 100%
        );
      }
    }
  `
);
